var isAnimationEnabled;
var checkIfScrollmagicLoaded;
function checkIfScrollmagicIsLoaded()
{
  if(typeof isScrollmagicLoaded != undefined)
  {
    clearInterval(checkIfScrollmagicLoaded);
    scriptLoadListener.isCriticalJsLoaded = 'thirdPartJsLoaded';
  }
}


function loadScript(url, callback = null){

    var script = document.createElement("script")
    script.type = "text/javascript";

    if (script.readyState){  //IE
        script.onreadystatechange = function(){
            if (script.readyState == "loaded" ||
                    script.readyState == "complete"){
                script.onreadystatechange = null;
                callback();
            }
        };
    } else {  //Others
        script.onload = function(){
            callback(url);
        };
    }

    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
}

function loadJsFiles(libraries, part = null)
{
  for( var i = 0; i < libraries.length; i++)
  {
    loadScript(libraries[i], function(jsFile){
      //initialization code
      if(jsFile.includes('lazysizes'))
      {
        document.getElementsByTagName("body")[0].classList.remove("page-load");
        scriptLoadListener.isCriticalJsLoaded = 'criticalJsLoaded';
      }
    });
    if( i == libraries.length - 1 && part != null )
    {
      if(part == 2)
      {
        scriptLoadListener.isCriticalJsLoaded = 'secondPartJsLoaded';
      }
      if(part == 3)
      {
        scriptLoadListener.isCriticalJsLoaded = 'thirdPartJsLoaded';
      }
      if(part == 4)
      {
        scriptLoadListener.isCriticalJsLoaded = 'fourthPartJsLoaded';
      }
    }
  }
}

window.addEventListener('DOMContentLoaded', (event) => {
  scriptLoadListener = {
    criticalJsLoaded: '',
    criticalJsListener: function(val) {},
    
    set isCriticalJsLoaded(val) {
      this.criticalJsLoaded = val;
      this.criticalJsListener(val);
    },
    get isCriticalJsLoaded() {
      return this.criticalJsLoaded;
    },
    registerListener: function(listener) {
      this.criticalJsListener = listener;
      this.secondPartJsListener = listener;
    }
  }

  scriptLoadListener.registerListener(function(val) {
    if(val == 'criticalJsLoaded')
    {
      let libraries = [
        "//supr-elegance-fashion.myshopify.com/cdn/shop/t/28/assets/swiper.min.js?v=33456648084306764411678083921",
        "//supr-elegance-fashion.myshopify.com/cdn/shop/t/28/assets/CSSPlugin.js?v=53845888360408729691678083928",
        "//supr-elegance-fashion.myshopify.com/cdn/shop/t/28/assets/isotope-masonry.js?v=96875624313649522131678083927"
      ];
      loadJsFiles(libraries, 2);
    }
    if(val == 'secondPartJsLoaded' && isAnimationEnabled)
    {
      let libraries = [
        "//supr-elegance-fashion.myshopify.com/cdn/shop/t/28/assets/tweenlite.js?v=131372992613236259441678083926",  
      ];
      loadJsFiles(libraries, 3);
    }
    if((val == 'thirdPartJsLoaded') || (val == 'secondPartJsLoaded' && !isAnimationEnabled))
    {
      let libraries = [
        "//supr-elegance-fashion.myshopify.com/cdn/shop/t/28/assets/instafeed.js?v=53340259927756987741678705570",
        "//supr-elegance-fashion.myshopify.com/cdn/shop/t/28/assets/functions.js?v=99312787580315473841678083927",
        "//supr-elegance-fashion.myshopify.com/cdn/shop/t/28/assets/custom.js?v=24862114545655770061681120292",
        "//supr-elegance-fashion.myshopify.com/cdn/shopifycloud/shopify/assets/themes_support/api.jquery-b0af070cfe3f5cf7c92f9e2a5da2665ee07ed2aad63bb408f8d6672f894a5996.js"
      ];
      loadJsFiles(libraries, 4);
    }
  });
  
  if(document.getElementsByTagName("BODY")[0].getAttribute('data-animation') == 'true')
  {
    isAnimationEnabled = true;
  }
  else
  {
    isAnimationEnabled = false;
  }
  
  let libraries = [
    "//supr-elegance-fashion.myshopify.com/cdn/shop/t/28/assets/ls.bgset.min.js?v=49817290196325828191678083925",
    "//supr-elegance-fashion.myshopify.com/cdn/shop/t/28/assets/lazysizes.min.js?v=99318634871119774751678083926",
    "//supr-elegance-fashion.myshopify.com/cdn/shop/t/28/assets/tweenmax.min.js?v=160489296794911516481678083927",
  ];
  loadJsFiles(libraries);

  document.addEventListener('readystatechange', function(ev) {
  });
});


// jQuery('li.cart-icon').click(function(){
//     jQuery('.cart-drawer').addClass('cart-drawer-open');
// });

// jQuery('.cart-drawer-close').click(function(){
//     jQuery('.cart-drawer').removeClass('cart-drawer-open');
// });